import React from "react"
import PropTypes from "prop-types"
import css from "./NoResult.scss"
import PrimaryButton from "@components/Buttons/PrimaryButton/PrimaryButton"
import ImageLoader from "@components/ImageLoader/ImageLoader"

function NoResult(props) {
    const { header, subHeader, imageUrl, ctaLabel, ctaAction, variant, col } = props

    return (
        <div className={`col-${col} alignCenter`}>
            <div className={`${variant === "lg" && css.container}`}>
                <div className={`${variant === "lg" ? css.largeImageContainer : css.smallImageContainer}`}>
                    {imageUrl && (
                        <ImageLoader src={imageUrl} alt={"No Result Found"} title={"No Result Found"} />
                    )}
                </div>

                {header && <div className={"l5SemiBold textCenter marginTop-16"}>{header}</div>}
                {subHeader && (
                    <div className={`bodyRegular textSecondary textCenter marginTop-4`}>{subHeader}</div>
                )}
                {ctaLabel && ctaAction && (
                    <div className={`marginTop-16 col-${col}`}>
                        <PrimaryButton label={ctaLabel} isOutlined onClick={ctaAction} />
                    </div>
                )}
            </div>
        </div>
    )
}

NoResult.propTypes = {
    header: PropTypes.string,
    subHeader: PropTypes.string,
    imageUrl: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaAction: PropTypes.func,
    variant: PropTypes.string,
    col: PropTypes.number,
}

NoResult.defaultProps = {
    variant: "sm",
}

export default NoResult
